import PropTypes from 'prop-types';
import styled from 'styled-components';
import CategoryLinkTile from './CategoryLinkTile/CategoryLinkTile';


const CategoryRow = styled.div`
  display: flex;
  margin-bottom: 10px;
  box-sizing: border-box;
`;

const StyledCategoryLinkTile = styled(CategoryLinkTile)`
  margin-right: 10px;
  width: ${({ categoriesPerRow }) => `${Math.round(100 / categoriesPerRow)}%`}
`;

// if last row has less categories than previous rows
// it has to be fulfill with this elements in order to have the same amount elements in row
// Otherwise there are margin and padding problems in the last row
const EmptyTileForLastRow = styled.div`
    margin-right: 10px;
    width: ${({ categoriesPerRow }) => `${Math.round(100 / categoriesPerRow)}%`};
    border: 2px solid transparent;
`;

const CategoryList = ({ categories, categoriesPerRow }) => {
  const numberOfRows = Math.ceil(categories.length / categoriesPerRow);
  const rows = [];

  for (let currentRow = 0; currentRow < numberOfRows; currentRow++) {
    rows.push(
      <CategoryRow key={currentRow}>
        {
          Array.from(Array(categoriesPerRow), (item, index) => index).map(
            (itemNumber) => (((itemNumber + (categoriesPerRow * currentRow)) < categories.length)
              ? (
                <StyledCategoryLinkTile
                  categoriesPerRow={categoriesPerRow}
                  {...categories[itemNumber + (categoriesPerRow * currentRow)]}
                  key={itemNumber}
                />
              )
              : <EmptyTileForLastRow categoriesPerRow={categoriesPerRow} key={itemNumber} />) // empty tile to keep layout of the last row non-broken
          )
        }
      </CategoryRow>
    );
  }
  return (
    <>
      {rows}
    </>
  );
};

CategoryList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  categoriesPerRow: PropTypes.oneOf([3, 5, 10]).isRequired
};


export default CategoryList;
